// core version + navigation, pagination modules:
import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay, FreeMode, EffectFade  } from 'swiper/modules';

function basicSlider(){
	const slider = new Swiper('[data-name="basic-slider"]', {
		modules: [Navigation, Pagination, Autoplay, FreeMode],
		loop: true,
		draggable: true,
		freeMode: {
			enabled: true,
		},
		allowTouchMove: true,
		effect: 'slide',
		spaceBetween: 20,
		slidesPerView: 1,

		pagination: {
			el: '.swiper-pagination',
			type: 'bullets',  // bullets, fraction (ex. 1/10), progressbar
			clickable: true,
		},
		navigation:{
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},

		breakpoints: {
			760: {
				slidesPerView: 1,
				spaceBetween: 20
			},
			992: {
				slidesPerView: 1,
				spaceBetween: 20
			},
		},
	});
}

function bannerSlider(){
	// Banner slider
	const swiperEl = document.querySelector('[data-name="banner-slider"]');
	if ( swiperEl ) {
		const currentSlideEl = swiperEl.parentElement.parentElement.querySelector('.current-slide');
		const totalSlidesEl = swiperEl.parentElement.parentElement.querySelector('.total-slides');	
		
		// Get navigation elements
		const nextBtn = swiperEl.querySelector('.swiper-button-next');
		const prevBtn = swiperEl.querySelector('.swiper-button-prev');
        
        // Get progress bar element
        const progressBarEl = swiperEl.parentElement.parentElement.querySelector('[data-name="banner-slider-progress"]');
	
		const bannerSlider = new Swiper(swiperEl, {
			modules: [Navigation, Pagination, Autoplay, EffectFade],
			slidesPerView: 1,
			autoplay: {
				delay: 5000,
			},
			navigation: {
				nextEl: nextBtn,
				prevEl: prevBtn,
			},
			effect: "fade",
			loop: true,
			fadeEffect: {
				crossFade: true,
			},
			speed: 800, // Set transition speed to 800ms for smooth fade
			on: {
				init: function() {
					updateCounter(this);
                    updateProgressBar(this);
				},
				slideChange: function() {
					updateCounter(this);
                    updateProgressBar(this);
				},
                autoplayTimeLeft: function(swiper, timeLeft, percentage) {
                    updateProgressBar(swiper, percentage);
                }
			}
		});

		function updateCounter(swiper) {
			const currentIndex = swiper.realIndex + 1;			
			const totalSlides = swiper.slides.length;
			
			if (currentSlideEl) {
				currentSlideEl.textContent = currentIndex < 10 ? `0${currentIndex}` : currentIndex;
			}
			
			if (totalSlidesEl) {
				totalSlidesEl.textContent = totalSlides < 10 ? `0${totalSlides}` : totalSlides;
			}
		}
        
        function updateProgressBar(swiper, percentage) {
            if (progressBarEl) {
                // Determine the current theme
                const isRedTheme = document.documentElement.classList.contains('theme-red') || 
                                   document.body.classList.contains('theme-red') ||
                                   document.getElementById('page-wrap')?.getAttribute('data-theme') === 'red';
                
                // Set colors based on theme
                const progressColor = isRedTheme ? '#FFFFFF' : '#FCBF00'; // White for red theme, Yellow for light theme
                const progressBg = isRedTheme ? 'rgba(255,255,255,0.3)' : 'rgba(0,0,0,0.1)';
                
                // If percentage is provided (from autoplayTimeLeft), use it
                // Otherwise calculate based on current slide
                if (percentage !== undefined) {
                    // Convert percentage to a width percentage (inverted since timeLeft starts at 100% and goes to 0%)
                    const width = (1 - percentage) * 100;
                    progressBarEl.style.background = `linear-gradient(to right, ${progressColor} ${width}%, ${progressBg} ${width}%)`;
                } else {
                    // For manual navigation, just highlight the progress proportionally
                    const currentIndex = swiper.realIndex;
                    const totalSlides = swiper.slides.length;
                    const progressPercentage = ((currentIndex + 1) / totalSlides) * 100;
                    progressBarEl.style.background = `linear-gradient(to right, ${progressColor} ${progressPercentage}%, ${progressBg} ${progressPercentage}%)`;
                }
            }
        }
	}
}

export { basicSlider, bannerSlider };